import React from 'react'
import { AnimalImages } from '../../../assets/early/animals/AnimalImagesPNG'

import { ReactComponent as VoiceOverButton } from '../../../assets/early/svg/VoiceOverButton.svg'
import { AnimalSounds } from '../../../assets/early/sounds/sounds'
import studentNameFrame from '../../../assets/early/svg/StudentNameFrame.svg'
import { useTranslation } from 'react-i18next'
import { EMOTION_ANIMAL_BACKGROUND_COLOR } from '../constants/Constants'
import i18n from '../../../i18n'
import '../../../styles/early/earlyMotion.css'

function AnimalEmotionButton({ animal = 'tiger', emotion = 'happy', onClick = () => {}, isSelected = false }) {
    const width = 182
    const { t } = useTranslation()
    const height = 195
    const [sound, setSound] = React.useState()
    const placeholderWidth = 146
    const placeholderHeight = 73

    const playSound = (e) => {
        e?.stopPropagation()
        const audio = new Audio(AnimalSounds[emotion])
        audio.play()
    }

    const isEn = i18n.language == 'en'
    return (
        <button
            className={`rounded-[25px] relative transition em-emotion ${isSelected ? 'em-emotion--selected' : ''}`}
            style={{
                backgroundColor: EMOTION_ANIMAL_BACKGROUND_COLOR[emotion],
                minWidth: width,
                width: width,
                height: height,
                borderWidth: 11,
                borderColor: isSelected ? '#FDDF6D' : '#7979aa',
            }}
            onClick={() => {
                onClick(emotion)
                if (!isSelected && isEn) playSound()
            }}
        >
            <img src={AnimalImages[animal ?? 'tiger'][emotion]} alt="Avatar" className="w-full h-full object-cover rounded-[25px]" />
            {isEn && (
                <button className="absolute right-[6px] bottom-[6px] em-tap" onClick={playSound} disabled={isSelected}>
                    <VoiceOverButton />
                </button>
            )}
            <div
                className="absolute -left-[10px] bg-no-repeat bg-contain flex flex-row items-center justify-center pl-[15px] pr-[11px]"
                style={{ backgroundImage: `url(${studentNameFrame})`, width: width, height: placeholderHeight, bottom: -73 }}
            >
                <p className="text-[16px] leading-5 font-bold text-[#FFFFFF] text-center overflow-hidden text-ellipsis line-clamp-3 capitalize">{t(emotion)}</p>
            </div>
        </button>
    )
}

export default AnimalEmotionButton
